export default "__VITE_ASSET__29ee8f16__"